export default __webpack_public_path__ + "static/1917-181ce6e41d46725df90e8c722e0a2264.gif";